export const POLICY_ROUTES = {
  list: '/workspace/:workspaceSlug/knowledge/policy',
  index: '/workspace/:workspaceSlug/policies',
  create: '/workspace/:workspaceSlug/knowledge/policy/new',
  edit: '/workspace/:workspaceSlug/knowledge/policy/:itemId',
  portal: '/portal/:slug/knowledge/policies'
};
